// extracted by mini-css-extract-plugin
export var infoRow = "_oa-2";
export var labelContainer = "_oa-0";
export var rightInfo = "_oa-1";